// Catálogos del formato oficial de subcontratación de servicios especializados
// (REPSE / ICSOE). No son catálogos del SAT ni del CFDI de nómina: son las
// listas cerradas que la propia plantilla oficial acepta en cada columna, y por
// eso viven aquí y no en un modelo de catálogo.

// Columna "Tipo de personal" de las dos hojas de la plantilla REPSE y del visor
// de XML emitidos. Se captura en el catálogo de Puestos y los empleados lo
// heredan de su puesto.
export const TIPO_PERSONAL_OPTIONS = ['Operativo', 'Administrativo', 'Profesional']

// Columna "Estatus del registro REPSE". Los textos van tal cual: la plantilla
// los valida contra esta lista exacta.
export const ESTATUS_REPSE_OPTIONS = [
  'Registro en autorización',
  'Registro vigente',
  'Registro en actualización',
  'Sin registro',
  'Registro cancelado',
]

// Columnas "¿...elementos propios...?" y "¿...dirección, supervisión o
// capacitación...?" de la hoja de contratos.
export const SI_NO_OPTIONS = ['SI', 'NO']
